module.exports = "body,\n.btn {\n  font-size: 0.91rem;\n}\n\n.display-5 {\n  font-size: 26px\n}\n\n.form-control {\n  padding: .355rem .55rem;\n  font-size: 0.91rem;\n}\n\nselect.form-control:not([size]):not([multiple]) {\n  height: calc(2.05rem + 2px);\n}\n\nngb-datepicker {\n  z-index: 99;\n}\n\n.input-group {\n  max-height: 35px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main